import script from "./AppForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AppForm.vue?vue&type=script&setup=true&lang=js"

import "./AppForm.vue?vue&type=style&index=0&id=ce4bae0c&lang=less"

const __exports__ = script;

export default __exports__